import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { MainLayout } from 'register-partners-js/react/components/layouts/main';
import { ErrorInfo } from 'register-partners-js/utils/error-info';

export default class RegistrationPricePlanRoute extends Route {
  mainLayout = MainLayout;

  @service intl;
  @service router;
  @service pricingService;
  @service sentry;
  @service segment;

  queryParams = {
    period: {
      replace: true,
    },
  };

  async model() {
    let registration = this.modelFor('registration');
    let organization = await registration.get('organization');

    return {
      registration,
      organization,
    };
  }

  setupController(controller, model, transition) {
    super.setupController(controller, model);

    controller.getPricePlansTask
      .perform({
        legalCountry: model.registration.organization.get('legalCountry'),
        partnerName: model.registration.partnerName?.toLowerCase(),
      })
      .catch(error => {
        if (ErrorInfo.for(error).shouldSendToSentry) {
          this.sentry.captureException(error);
        }
        this.send('error', new Error(error), transition);
        transition?.abort();
      });
  }

  activate() {
    this.intl.onLocaleChanged(this.refresh, this);
  }

  redirect({ registration }, transition) {
    if (
      (!transition.from ||
        (transition.from?.name !== 'registration.payment' &&
          transition.from?.name !== 'registration.owner-info' &&
          transition.from?.name !== 'react' &&
          transition.from?.name !== 'registration.price-plans' &&
          transition.from?.name !== 'registration.price-plans.offers')) &&
      registration.pricePlanCode
    ) {
      this.router.replaceWith('registration.payment');
    }
  }
}
